import { render } from "./ZMoney.vue?vue&type=template&id=82e44e46"
import script from "./ZMoney.vue?vue&type=script&lang=js"
export * from "./ZMoney.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/aims/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__